import { gql } from './graphql';

export interface YardSpotLatestHistory {
  id: string;
  timestamp: string;
  verdict: string | null;
  matchConfidence: number | null;
  expectedMatch: string | null;
  trailerNumberExpected: string | null;
  trailerNumberOcrReading: string | null;
  trailerNumberOcrConfidenceScore: number | null;
  trailerBrandExpected: string | null;
  trailerBrandOcrReading: string | null;
  trailerBrandOcrConfidenceScore: number | null;
  fullImgUrl: string | null;
  croppedImgUrl: string | null;
  processedImgUrl: string | null;
  annotatedCropUrl: string | null;
  deviceOrientation: string | null;
  lat: number | null;
  lon: number | null;
  deviceHeading: number | null;
  positionSource: string | null;
  spotterTruckUuid: string | null;
  deviceUuid: string | null;
  needsReview: boolean;
}

export interface YardSpotRtlsCheck {
  yardSpotUuid: string;
  yardSpotName: string | null;
  yardSpotOrderNumber: string | null;
  latestHistory: YardSpotLatestHistory | null;
}

export interface FacilityZoneYardChecks {
  facilityZoneUuid: string | null;
  facilityZoneName: string | null;
  yardSpots: YardSpotRtlsCheck[];
}

export interface YardChecksSummary {
  totalYardSpots: number;
  freshCount: number;
  staleCount: number;
  coldCount: number;
  notSeenCount: number;
}

export interface YardChecksResponse {
  summary: YardChecksSummary;
  facilityZones: FacilityZoneYardChecks[];
}

const YARD_CHECKS_BY_FACILITY = `
  query YardChecksByFacility($facilityId: ID!) {
    yardChecksByFacility(facilityId: $facilityId) {
      summary {
        totalYardSpots
        freshCount
        staleCount
        coldCount
        notSeenCount
      }
      facilityZones {
        facilityZoneUuid
        facilityZoneName
        yardSpots {
          yardSpotUuid
          yardSpotName
          yardSpotOrderNumber
          latestHistory {
            id
            timestamp
            verdict
            matchConfidence
            expectedMatch
            trailerNumberExpected
            trailerNumberOcrReading
            trailerNumberOcrConfidenceScore
            trailerBrandExpected
            trailerBrandOcrReading
            trailerBrandOcrConfidenceScore
            fullImgUrl
            croppedImgUrl
            processedImgUrl
            annotatedCropUrl
            deviceOrientation
            lat
            lon
            deviceHeading
            positionSource
            spotterTruckUuid
            deviceUuid
            needsReview
          }
        }
      }
    }
  }
`;

export async function fetchYardChecksByFacility(
  facilityId: string | number
): Promise<YardChecksResponse | null> {
  const data = await gql<{ yardChecksByFacility: YardChecksResponse | null }>(
    YARD_CHECKS_BY_FACILITY,
    { facilityId }
  );
  return data.yardChecksByFacility || null;
}
